const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CustomerQuery: any = {
    GetSingleCustomer: Backofficebff + '/v1/customer',
    GetCustomerById: Backofficebff + '/v1/customer',
    GetAcountListByCustomerId: Backofficebff + '/v1/customer/getacountlistbycustomerid',
    GetCustomerRiskStatusByCustomerId: Backofficebff + '/v1/customer/getcustomerriskstatusbycustomerid',
    GetCustomerOptInByCustomerId: Backofficebff + '/v1/customer/customer-optin-by-customer-id',
    GetCustomerReturnList: Backofficebff + '/v1/return/searchreturn',
    GetReturnDetailByReturnId: Backofficebff + '/v1/return/getreturndetailbyreturnid',
    GetGiftCardDatas: Backofficebff + '/v1/customer/get-gift-card-by-customerId',
    GetGiftCardTransactionDatas: Backofficebff + '/v1/customer/get-card-transaction-list-by-customerid',
    GetBankAccount: Backofficebff + '/v1/customer/getbankaccount',
    GetCustomerContactMessageList: Backofficebff + '/v1/customer/get-customer-contact-messages',
    GetCustomerContactMessageById: Backofficebff + '/v1/customer/get-customer-contact-messages-by-id',
    GetRptTopic: Backofficebff + '/v1/customer/get-rpt-topic',
    GetRptSubTopics: Backofficebff + '/v1/dynamiclive/get-rpt-sub-topic',
    GetCustomerDeviceDetails: Backofficebff + '/v1/customer/get-customer-device-details',
    GetCustomerSubMenuFromRule: Backofficebff + '/v1/customer/get-customer-submenu-from-rule-service',
    GetCustomerManagementCustomer: Backofficebff + '/v1/customer/get-customer',
    GetCustomerAccountHistory: Backofficebff + '/v1/customer/search-with-customer-logs',
    DisableLcwMoneyTransfer: Backofficebff + '/v1/customer/disable-lcw-money-transfer',
};
